export enum TradeInOption {
	NEW = "NEW",
	SEND_IN = "SEND_IN",
	KEEP = "KEEP",
}
